import {dashboardRoutes} from "./routes/dashboardRoutes"
import {authenticationRoutes} from "./routes/authentication"
import {errorRoutes} from "./routes/error"
import {masterDataRoutes} from "./routes/masterData"
import {publicRoute} from "./routes/publicRoutes"
import { mahasiswaDataRoutes } from './routes/mahasiswaData'
import {adminDataRoutes} from "./routes/adminPages";
import { DosenRoutes } from './routes/dosenRoutes'
import {keuanganRolesPages} from "./routes/keuanganRolesPages";

export const publicRoutes = [
    ...publicRoute
]

export const protectedRoutes = [
    ...dashboardRoutes,
    ...authenticationRoutes,
    ...errorRoutes,
    ...adminDataRoutes,
    ...masterDataRoutes,
    ...mahasiswaDataRoutes,
    ...DosenRoutes,
    ...keuanganRolesPages,

]